'use client'

import { useIdentity } from '@/lib/hooks/useIdentity'
import FeaturedShowsRow from './FeaturedShowsRow';
import { useHasMounted } from '@/lib/hooks';
import TopPicksShowRow from './TopPicksShowRow';
import { ShowRowContent } from '@/lib/types/api/show-data';

import type { ShowBadgeFlags } from '@/components/ShowPoster/ShowPoster';

interface TopPicksOrFeaturedShowsRowProps {
  featuredShows: ShowRowContent[];
  showBadgeFlags?: ShowBadgeFlags;
}

const TopPicksOrFeaturedShowsRow = (props: TopPicksOrFeaturedShowsRowProps) => {
  const { featuredShows, showBadgeFlags } = props;
  const hasMounted = useHasMounted();
  const { isAuthenticated } = useIdentity()

  // Checks if component is mounted on the client before attempting to 
  // hydrate, otherwise a hydration error occurs
  if (!hasMounted) {
    return null;
  }

  // Render Top Picks Show Row only if the user is signed in
  // otherwise render the Featured Shows Row
  if (isAuthenticated) {
    return <TopPicksShowRow featuredShows={featuredShows} showBadgeFlags={showBadgeFlags} />
  } else {
    return (
      <FeaturedShowsRow shows={featuredShows} showBadgeFlags={showBadgeFlags} />
    )
  }
}

export default TopPicksOrFeaturedShowsRow;
